module.exports = __webpack_public_path__ + "static/media/corporate-services-img50.88b8d3b4.jpg";